export default __webpack_public_path__ + "c7ee4b39ef11eb597a1b6e5ae1b3e87f.png";